import React, { useState } from 'react';
import { Button, SwipeableDrawer, useMediaQuery } from '@material-ui/core';
import VerticalAlignBottomIcon from '@material-ui/icons/VerticalAlignBottom';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles({
  containerStyle: {
    width: 400,
    margin: '1em',
  },
  swipeStyle: {
    position: 'fixed',
    right: 20,
    top: '50%',
    minWidth: 'initial',
    width: '45px',
    height: '45px',
    borderRadius: '50%',
  },
  swipeIcon: {
    fontSize: '24px',
    transform: 'rotate(90deg)',
  },
});

const ResponsiveAside = ({ children }) => {
  const classes = useStyles();
  const isSmall = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const [swipe, setSwipe] = useState(false);
  const toggleDrawer = (open) => (event) => {
    if (
      event &&
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }

    setSwipe(open);
  };
  if (isSmall) {
    return (
      <React.Fragment key="right">
        <Button
          variant="contained"
          title="Swipe"
          onClick={toggleDrawer(true)}
          color="primary"
          className={classes.swipeStyle}
        >
          <VerticalAlignBottomIcon className={classes.swipeIcon} />
        </Button>
        <SwipeableDrawer
          anchor="right"
          open={swipe}
          onClose={toggleDrawer(false)}
          onOpen={toggleDrawer(true)}
        >
          {children}
        </SwipeableDrawer>
      </React.Fragment>
    );
  }
  return <div className={classes.containerStyle}>{children}</div>;
};

export default ResponsiveAside;
